export interface OnboardFormValues {
  name: string;
  email: string;
  password: string;
  locationName: string;
  address: string;
  city: string;
  zip: string;
  phone: string;
}

export const DEFAULT_ONBOARD_FORM_VALUES: OnboardFormValues = {
  name: '',
  email: '',
  password: '',
  locationName: '',
  address: '',
  city: '',
  zip: '',
  phone: '',
};

export type OnboardAuthMode = 'password' | 'google';

export const ONBOARD_PASSWORD_MIN_LENGTH = 8;

export const ONBOARD_OAUTH_STORAGE_KEY = 'gb_onboard_oauth';
export const ONBOARD_TOKENS_STORAGE_KEY = 'gb_onboard_tokens';

export interface OnboardOAuthDraft {
  intent: 'onboard';
  checkoutSessionId: string | null;
  returnPath: string;
}

export interface OnboardStoredTokens {
  access_token: string;
  refresh_token?: string;
  expires_in?: number;
}



// WEBPACK FOOTER //
// ./src/types/onboard.ts